module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"onfield_cancel.page.title":"ยกเลิกงาน {serviceId} เรียบร้อย","onfield_cancel.page.button":"เปิดใบซ่อมใหม่"}}')
  delete Component.options._Ctor
}
